module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/social/fb-new.svg
// module id = 126
// module chunks = 1